import React, {PureComponent} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor';
import firstCard from '../assets/img/first_card.png';
import secondCard from '../assets/img/second_card.png';
import thirdCard from '../assets/img/third_card.png';
import Card from '../common/Card';

class AdvantagesComp extends PureComponent {
  render() {
    return (
      <ScrollableAnchor id={'advantages'}>
        <Container className="container-full partners-container">
          <div className="partners-title advantages-title">
            Les <span className="bold-word">avantages</span> de Clean<span className="bold-word">Bill</span>
          </div>
          <div className="partners-cards">
            <Row className="card-row">
              <Col xs={12} lg={4} className="card-col">
                <Card
                  img={firstCard}
                  title={'Vos cartes de fidélité au bout des doigts'}
                  width="100%"
                  customClass="advantages-card"
                  customImgClass="advantages-card-img "
                >
                  Toutes vos cartes de fidélité sont à portée de main avec une seule application :
                  <span className='strong-span'> Clean Bill</span>. Oubliez les
                  fouilles interminables dans votre porte-monnaie quand vous passez à la caisse.
                  <span className='strong-span'> Tendez votre
                  smartphone : tous vos points et vos avantages sont là.</span>
                </Card>
              </Col>
              <Col xs={12} lg={4} className="card-col">
                <Card
                  img={secondCard}
                  title={'Un seul endroit pour vos tickets de caisse et factures : votre mobile'}
                  width="100%"
                  customClass="advantages-card"
                  customImgClass="advantages-card-img"
                >
                  <span className='strong-span'>Clean Bill</span> vous épargne les énormes piles de factures entassées :
                  votre application les stocke toutes.
                  <span className='strong-span'> Avec elle, ne perdez plus la moindre preuve d’achat.</span>
                </Card>
              </Col>
              <Col xs={12} lg={4} className="card-col">
                <Card
                  img={thirdCard}
                  title={'Passez au dématérialisé et n’oubliez plus jamais une note de frais'}
                  width="100%"
                  customClass="advantages-card"
                  customImgClass="advantages-card-img"
                >
                  Automatisez le rangement, classez, transférez vos notes de frais sans jamais les imprimer <span className='strong-span'>grâce à
                  Clean Bill. Fini les dépenses oubliées, rien n’échappe à votre application !</span>
                  <br/>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </ScrollableAnchor>
    );
  }
}

export default AdvantagesComp;
